export default __webpack_public_path__ + "static/Data-visualization-9b8db5de78d60bf06a585a196d5fff13.webp";